import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';

import { MicrosoftHealthCheckBanner_MicrosoftFragment } from 'src/generated/mloop-graphql';

import AppWideBanner, { AppWideBannerAction } from '../AppWideBanner';

interface Fragments {
  microsoft: MicrosoftHealthCheckBanner_MicrosoftFragment;
}

interface Props {
  retry: AppWideBannerAction;
}

const MicrosoftHealthCheckBanner: FCWithFragments<Fragments, Props> = ({ microsoft, retry }) => {
  const { t } = useTranslation();
  // hide if its not installed or is healthy
  if (!microsoft || !microsoft?.isInstalled || microsoft?.isHealthy) {
    return null;
  }

  const issues = [
    !microsoft.canReadDirectory && t('hiring-dashboard-nav:nav.banner.endpoint.employeeDirectory'),
    !microsoft.canReadCalendars && t('hiring-dashboard-nav:nav.banner.endpoint.calendars'),
    !microsoft.canReadMeetingRooms && t('hiring-dashboard-nav:nav.banner.endpoint.meetingRooms'),
  ].filter(Boolean) as string[];

  const text =
    issues.length > 0
      ? t('hiring-dashboard-nav:nav.banner.integrationUnhealthyWithEndpoints', {
          integrationName: 'Microsoft 365',
          endpoints: issues,
        })
      : t('hiring-dashboard-nav:nav.banner.integrationUnhealthy', { integrationName: 'Microsoft 365' });

  return <AppWideBanner color="foreground" backgroundColor="error" text={text} action={retry} />;
};

MicrosoftHealthCheckBanner.fragments = {
  microsoft: gql`
    fragment MicrosoftHealthCheckBanner_microsoft on MicrosoftIntegrationHealth {
      isHealthy
      isInstalled
      canReadDirectory
      canReadCalendars
      canReadMeetingRooms
    }
  `,
};

export default MicrosoftHealthCheckBanner;
